module.exports = __webpack_public_path__ + "static/img/image81.516b6bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c34/image81.png
// module id = Pm8r
// module chunks = 0